import React from 'react'
import axios from 'axios'
import styles from './Signup.module.scss'
import { countries } from '../../Application/appData'


class Fellows extends React.Component {
    constructor(props) {
        super(props)

        const today = new Date();
        const date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();

        this.state = {
            firstname: '',
            lastname: '',
            email: '',
            country:'',
            birthMonth: '',
            birthDay:'',
            birthYear:'',
            uwcNetwork:'',
            currentlyIn:'',
            interestedIn:'',
            uwcNetwork: false,
            newsletter:true
        }


        props.fieldKey ? this.state[props.fieldKey] = props.fieldValue : null

        this.valueUpdater = this.valueUpdater.bind(this)

        this.days = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
        this.years = [1992,1993,1994,1995,1996,1997,1998,1999,2000,2001,2002,2003,2004,2005,2006,2007,2008]
    }


    valueUpdater = field => (event) => {
        let value = event.target.value;
        const newState = {
          ...this.state,
          [field]: value,
        };
        this.setState(newState);
    }

    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');

        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length).replace('%20\g', ' ')
            }
        }
        return "";
    }


    get_ga_params() {
        var utmz = this.getCookie("__utmz")
        var vals = (function() {
            var pairs = utmz.split('.').slice(4).join('.').split('|');
            var ga = {};
            for (var i = 0; i < pairs.length; i++) {
                var temp = pairs[i].split('=');
                ga[temp[0]] = temp[1];
            }
            return ga;
        })();
        return vals;
    }

    getUrlParams(search) {
        let hashes = search.slice(search.indexOf('?') + 1).split('&')
        return hashes.reduce( (params, hash) => {
            let [key, val] = hash.split('=')
            return Object.assign(params, {[key]: decodeURIComponent(val)})
        }, {} )
    }

    getUTMCookies() {
        return {
            utm_source: this.getCookie('utm_source'),
            utm_medium: this.getCookie('utm_medium'),
            utm_term: this.getCookie('utm_term'),
            utm_content: this.getCookie('utm_content'),
            utm_campaign: this.getCookie('utm_campaign')
        }
    }

    validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    handleSubmit(e) {
        let gaParams = this.get_ga_params()
        //let urlParams = this.getUTMCookies()
        const user_id = this.getCookie('intercom-id-qee5suad')
        this.setState({
            utm_medium: gaParams.utmcmd ? gaParams.utmcmd : '--',
            utm_source: gaParams.utmcsr ? gaParams.utmcsr : '--',
            utm_term: gaParams.utmctr ? gaParams.utmctr : '--',
            utm_content: gaParams.utmcct ? gaParams.utmcct : '--',
            utm_campaign: gaParams.utmccn ? gaParams.utmccn : '--',
            // utm_source: urlParams.utm_source ? urlParams.utm_source : '--',
            // utm_medium: urlParams.utm_medium ? urlParams.utm_medium: '--',
            // utm_term: urlParams.utm_term ? urlParams.utm_term : '--',
            // utm_content: urlParams.utm_content ? urlParams.utm_content : '--',
            // utm_campaign: urlParams.utm_campaign ? urlParams.utm_campaign : '--',
            user_id: user_id
        }, () => {
            var url = this.props.zap
            !this.props.zap ? url = 'https://hooks.zapier.com/hooks/catch/1060428/ortqeas/' : null
            //var url='https://hooks.zapier.com/hooks/catch/1060428/q2tpnj/' // facebook
            //var url='https://hooks.zapier.com/hooks/catch/1060428/q2t724/' // google ads

            if (this.validateEmail(this.state.email) &&
                this.state.firstname != '' &&
                this.state.lastname != '' &&
                this.state.birthMonth != '' &&
                this.state.birthYear != '' &&
                this.state.birthDay != '') {
                axios.post(url, JSON.stringify(this.state)).then( res => {
                    if (res.data.status == 'success') {
                        typeof ORIBI !== 'undefined' ? ORIBI.api('setUserEmail', this.state.email) : null
                        window.location.replace(`/thank-you-for-your-interest/?email=${encodeURIComponent(this.state.email)}&firstname=${encodeURIComponent(this.state.firstname)}&lastname=${encodeURIComponent(this.state.lastname)}`)
                    }
                    else {
                        this.refs.error.style.display = 'block'
                        this.refs.emailError.style.display = 'none'
                    }
                })
            }
            else {
                this.refs.required.style.display = 'block'
                this.refs.reqMessage.style.display = 'block'
                if (this.validateEmail(this.state.email) ) {
                    this.refs.emailError.style.display = 'none'
                }
                else {
                    this.refs.emailError.style.display = 'block'
                }
            }
        })
  }

  updateCheckboxes = field => event => {
      const index = this.state.countries.indexOf(field)
      if (index !== -1) {
          // item is in array so remove
          this.setState({ countries: [...this.state.countries.slice(0, index),
            ...this.state.countries.slice(index + 1)]
        }, () => {
            // console.log(this.state.countries)
        })
      }
      else {
          // item is not in array, so add this item
          this.setState({ countries: [...this.state.countries, field] }, () =>  {
                   // console.log(this.state.countries)
           })
      }
  }

  handleCheckbox(e) {
      this.setState({
          newsletter: !this.state.newsletter
      }, function() {
          this.valueUpdater('newsletter')
      })
  }
  handleUWCCheckbox(e) {
      this.setState({
          uwcNetwork: !this.state.uwcNetwork
      }, function() {
          this.valueUpdater('uwcNetwork')
      })
  }

  render() {
      let formColor = this.props.color ? this.props.color : null
      formColor = formColor == 'Green' ? '#16C58E' : formColor
    // console.log('FORM PROPS ==>', this.props);
    return (
      <div className={`${styles.Signup} ${this.props.color}`} style={{ background: formColor }}>
        <div className={styles.Signup__Wrapper}>
        <h2>{this.props.title}</h2>
        <p>For interested students, sign up here to learn more about our programs! For educators, visit our <a href="https://www.globalcitizenyear.org/nominate-a-student/">educator form</a> to request more information</p>
        <form ref="inquiryForm">
          <div className={styles.FormRow}>
            <div className={`${styles.FormElement} ${this.state.firstname !== '' ? styles.FormElementActive : ''}`}>
              <input id="firstname-entry" required type="text" name='firstname' value={this.state.firstname} onChange={this.valueUpdater('firstname')} />
              <label htmlFor="firstname-entry">First Name*</label>
            </div>
            <div className={`${styles.FormElement} ${this.state.lastname !== '' ? styles.FormElementActive : ''}`}>
              <input type="text" required id="lastname-entry" name='lastname' value={this.state.lastname} onChange={this.valueUpdater('lastname')} />
              <label htmlFor="lastname-entry">Last Name*</label>
            </div>
            <div className={`${styles.FormElement} ${this.state.email !== '' ? styles.FormElementActive : ''}`}>
                <input type="email" required id="email-entry" name='email' value={this.state.email} onChange={this.valueUpdater('email')} />
                <label htmlFor="email-entry">Email Address*</label>
                <span ref="emailError" style={{ color:'red', fontSize:'12px', display:'none' }} className="email-error">* Please enter a valid email address.</span>
            </div>
          </div>
          <div className={`${styles.FormRow}`}>
              <p style={{ display:'block',marginBottom:0,paddingBottom:0,top:'6px','position':'relative'}}>Birthdate</p>
          </div>
          <div className={`${styles.FormRow} signup-birth`}>
              <div className={`${styles.FormElement} ${styles.FormElementSelect} ${this.state.birthMonth !== '' ? styles.FormElementActive : ''}`}>
                <select name="birthMonth" id="gradyear-entry" required onChange={this.valueUpdater('birthMonth')}>
                  <option value="" selected disabled hidden></option>
                  <option value="Jan">Jan</option>
                  <option value="Feb">Feb</option>
                  <option value="Mar">Mar</option>
                  <option value="Apr">Apr</option>
                  <option value="May">May</option>
                  <option value="Jun">Jun</option>
                  <option value="Jul">Jul</option>
                  <option value="Aug">Aug</option>
                  <option value="Sep">Sep</option>
                  <option value="Oct">Oct</option>
                  <option value="Nov">Nov</option>
                  <option value="Dec">Dec</option>
                </select>
                <label htmlFor="birthMonth">Month*</label>
              </div>

               <div className={`${styles.FormElement} ${styles.FormElementSelect} ${this.state.birthDay !== '' ? styles.FormElementActive : ''}`}>
                 <select name="birthDay" id="gradyear-entry" required onChange={this.valueUpdater('birthDay')}>
                   <option value="" selected disabled hidden></option>
                      { this.days.map( (day, index) =>
                          <option key={ index } value={ day }>{ day }</option>
                      )}
                 </select>
                 <label htmlFor="birthDay">Day*</label>
               </div>

                <div className={`${styles.FormElement} ${styles.FormElementSelect} ${this.state.birthYear !== '' ? styles.FormElementActive : ''}`}>
                  <select name="birthYear" id="gradyear-entry" required onChange={this.valueUpdater('birthYear')}>
                    <option value="" selected disabled hidden></option>
                       { this.years.map( (year, index) =>
                           <option key={ index } value={ year }>{ year }</option>
                       )}
                  </select>
                  <label htmlFor="birthYear">Year*</label>
                </div>
             </div>


            { /* <div className={styles.FormRow}>
              <div className={`${styles.FormElement} ${styles.FormElementSelect} ${this.state.country !== '' ? styles.FormElementActive : ''}`}>
                <select name="gradyear" id="gradyear-entry" required onChange={this.valueUpdater('country')}>
                  <option value="">Select a country...*</option>
                  <option value="United States">United States</option>
                  { countries.map( (country, index) => <option key={index} value={ country }>{ country }</option> )}
                </select>
              </div>
              <div className={`${styles.FormElement} ${styles.FormElementSelect} ${this.state.currentlyIn !== '' ? styles.FormElementActive : ''}`}>
                <select name="currentlyIn" required id="uwc" onChange={this.valueUpdater('currentlyIn')}>
                  <option value="" selected disabled hidden></option>
                  <option value=" In High School (not graduating this year)"> In High School (not graduating this year)</option>
                  <option value="In High School (graduating this year)">In High School (graduating this year)</option>
                  <option value="In College">In College</option>
                  <option value="On a gap year before college">On a gap year before college</option>
                  <option value="On a gap year during college">On a gap year during college</option>
                  <option value="Working (no college)">Working (no college)</option>
                </select>
                <label htmlFor="currentlyIn">I am currently...*</label>
              </div>
              </div> */ }


          { /* <div className={styles.FormRow}>
            <div className={`${styles.FormElement} ${styles.FormElementSelect} ${this.state.interestedIn !== '' ? styles.FormElementActive : ''}`}>
              <select name="interestedIn" id="gradyear-entry" required onChange={this.valueUpdater('interestedIn')}>
                <option value="" selected disabled hidden></option>
                <option value="The Academy">The Academy</option>
                <option value="The Fellowship">The Fellowship</option>
                <option value="Both">Both</option>
              </select>
              <label htmlFor="interestedIn">I am interested in...*</label>
            </div>
            <div></div>
          </div>
          <div className={styles.FormRow}>
            <div className={`${styles.FormElement} ${this.state.uwcNetwork !== '' ? styles.FormElementActive : ''} signup-check-option`}>
              <input onChange={ e => { this.handleUWCCheckbox(e) }} type="checkbox" name="uwcNetwork" value={ this.state.uwcNetwork } checked={ this.state.uwcNetwork == true ? 'checked' : false } id="uwc" />
              <label htmlFor="uwcNetwork">Is your high school part of the United World College network?*</label>
            </div>
            </div> */ }
          <div className={styles.FormRow}>
              <div className={`${styles.FormElement}`}>
                <div className="signup-check-option">
                   <input onChange={ e => { this.handleCheckbox(e) }} type="checkbox" name="subscribed" value={ this.state.newsletter } checked={ this.state.newsletter == true ? 'checked' : false }/>
                   <label>* I would like to subscribe to the Global Citizen Year newsletter to receive news and updates.</label>
                </div>
              </div>
          </div>
          <div ref="interestForm" onClick={ () => this.handleSubmit() } style={{ marginLeft: 0 }} className={styles.Button}>
            Submit
            <svg width="21px" height="10px" viewBox="0 0 21 10" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
                    <g id="GCY---request-info-form-@2x-updated-Copy-4" transform="translate(-286.000000, -769.000000)" stroke="#222222" strokeWidth="1.5">
                        <g id="request-info">
                            <g id="button---submit" transform="translate(193.000000, 743.000000)">
                                <g id="Group-9" transform="translate(94.000000, 27.000000)">
                                    <polyline id="Line-2" points="15 0 19 4 15 8"></polyline>
                                    <path d="M0,4 L18,4" id="Line-3"></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
          </div>
        </form>
        <div ref="required" style={{ display: 'none', marginTop:'10px' }}>
            <p style={{ color: 'red' }} ref="reqMessage">* Please fill out all required fields</p>
        </div>
        <div ref="success" style={{ display: 'none', marginTop:'10px' }}>
            <p ref="successMessage">Thank you for your submission. We will contact you shortly!</p>
        </div>
        <div ref="error" style={{ display: 'none', marginTop:'10px' }}>
            <p style={{ color: 'red' }}>Something went wrong with your sumbission. Please try again!</p>
        </div>
        </div>
      </div>
    )
  }
}

export default Fellows;



// WEBPACK FOOTER //
// ./src/components/Shared/Signup/index.js